import { useMatches } from "react-router";

interface MatchWithHeaderDisplayName {
  handle?: { headerDisplayName?: string };
}

export function useActiveRouteFriendName(): string | undefined {
  const matches = useMatches();
  const lastMatch = matches[matches.length - 1] as MatchWithHeaderDisplayName; // TODO: try to strongly type this.
  return lastMatch.handle?.headerDisplayName;
}
